import {api} from './client';
import {Session} from "@/api/types/Session";
import {Authentication} from "@/api/types/Authentication";

export type LoginForm = {
    email: string,
    password: string,
};

type ListParams = {
    limit?: number,
    skip?: number,
    search?: string,
};

export type AuthenticationData = {
    limit: number,
    skip: number,
    total: number,
    data: Authentication[]
}


export const buildSessionsApi = (client = api) => {
    return {
        async login(form: LoginForm) {
            const result = await client.post<Session>('session', form);
            return result.data;
        },

        async logout(id: string) {
            await client.delete(`session/${id}`)
        },

        async list(limit: number, skip: number, search: string) {
            const params: ListParams = { limit: limit, skip: skip, search: search }
            const result = await client.get<AuthenticationData>('auth', { params })
            return result.data
        }
    };
};

export const {
    login,
    logout,
    list,
} = buildSessionsApi();
